import { render, staticRenderFns } from "./ModalApproved.vue?vue&type=template&id=f2164ad8&scoped=true&"
import script from "./ModalApproved.vue?vue&type=script&lang=js&"
export * from "./ModalApproved.vue?vue&type=script&lang=js&"
import style0 from "./ModalApproved.vue?vue&type=style&index=0&id=f2164ad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2164ad8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDialog,VDivider})
